import { Component } from '@angular/core';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-divider',
  imports: [MatDivider],
  templateUrl: './divider.html',
  styleUrl: './divider.scss'
})
export class Divider {

}
